<template>
	<transition name="banded_alert">
		<div class="banded" v-if="bandedType">
			<p v-if="bandedType==1">禁言解除，可以发言啦！</p>
			<p v-else-if="bandedType==2">你发的太快了，休息一下吧~</p>
			<p v-else-if="bandedType==3">正在禁言，认真听课吧！</p>
			<p v-else-if="bandedType==4">老师关闭了打字功能，开启后再使用吧</p>         
			<p v-else-if="bandedType==5">班主任老师关闭了你的打字功能，要认真听课噢！</p>         
			<p v-else-if="bandedType==6">请稍后...</p>
			<p v-else-if="bandedType==7">语音通话中</p>
		</div>
	</transition>
</template>

<script>
export default {
  name: "bandedAlert",
  props: {
    bandedType: {
      type: [String, Number],
      default: ""
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.banded {
  background: #4a4542;
  position: absolute;
  z-index: 90;
  left: 50%;
  top: 106px;
  height: 72px;
  min-width: 202px;
  border-radius: 37px;
  padding: 0 20px;
  font-family: PingFang_Medium;
  transform: translateX(-50%);
  &::after {
    position: absolute;
    content: " ";
    border-bottom: 13px solid #4a4542;
    border-left: 13px solid transparent;
    transform: rotate(-135deg);
    top: -6px;
    border-bottom-right-radius: 2px;
  }
  p {
    font-size: 24px;
    color: #ffffff;
    line-height: 72px;
  }
}

.banded_alert-enter-active {
  animation: zoomIn 0.4s cubic-bezier(0.745, 0, 0.31, 0.995);
}

.banded_alert-leave-active {
  animation: zoomIn 0.4s reverse cubic-bezier(0.745, 0, 0.31, 0.995);
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/video/bandedAlert.vue